import { FulfillmentsApiClient } from '@fourthwall/services/dist/FulfillmentsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useUnfulfilledCountQuery = createQueryHook(FulfillmentsApiClient.getUnfulfilledCount, {
  queryKey: ['unfulfilledCount'],
})
